import {Card, CardContent, CardHeader, CardTitle} from "@/components/ui/card";
import {Users} from "lucide-react";
import {cn} from "@/lib/utils";
import {useStoredUserProperty} from "@/src/modules/core/store/user-property";

import {
  DISPATCH_DESK_BLOCK_HEADER_CLASS,
  DISPATCH_DESK_BLOCK_TITLE_CLASS,
  DISPATCH_DESK_CARD_CLASS,
  DISPATCH_DESK_PANEL_SHELL_CLASS,
  DispatchDeskEmptyPanelBody,
  DispatchDeskHeaderIconRow,
  DISPATCH_DESK_CONTENT_MUTED_CLASS,
} from "./dispatch-desk-card";

type DispatchCoverageEmptyProps = {
  className?: string;
};

export function DispatchCoverageEmpty({className}: DispatchCoverageEmptyProps) {
  const userProperty = useStoredUserProperty();

  const message = userProperty?.id
    ? "No officers on duty"
    : "No active shift coverage for your dispatch center.";

  return (
    <Card className={cn(DISPATCH_DESK_CARD_CLASS, DISPATCH_DESK_PANEL_SHELL_CLASS, className)}>
      <CardHeader className={DISPATCH_DESK_BLOCK_HEADER_CLASS}>
        <DispatchDeskHeaderIconRow icon={Users}>
          <CardTitle className={DISPATCH_DESK_BLOCK_TITLE_CLASS}>On duty</CardTitle>
        </DispatchDeskHeaderIconRow>
      </CardHeader>
      <CardContent className="flex min-h-0 flex-1 flex-col pt-0">
        <DispatchDeskEmptyPanelBody>
          <p className={DISPATCH_DESK_CONTENT_MUTED_CLASS}>{message}</p>
        </DispatchDeskEmptyPanelBody>
      </CardContent>
    </Card>
  );
}
